/** @jsxImportSource @emotion/react */
import { createStyles, Input, UtilityButton } from '@quickbit/qb-design-system';
import { useState } from 'react';

interface MessageInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export const MessageInput = ({
  onSend,
  disabled = false,
}: MessageInputProps) => {
  const styles = useStyles();
  const [message, setMessage] = useState('');

  const handleSend = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage && !disabled) {
      onSend(trimmedMessage);
      setMessage('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div css={styles.container}>
      <div css={styles.inputWrapper}>
        <Input
          type="textarea"
          value={message}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            setMessage(e.target.value)
          }
          onKeyDown={handleKeyDown}
          label="Type a message..."
          disabled={disabled}
        />
      </div>
      <UtilityButton
        text="Send"
        variant="primary"
        onClick={handleSend}
        disabled={disabled || !message.trim()}
      />
    </div>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    gap: spacing.xs,
    padding: spacing.xs,
    borderTop: '1px solid #e0e0e0',
    alignItems: 'center',
  },
  inputWrapper: {
    flex: 1,
  },
}));
